import axios from "axios";

export const getQrMenuDetails = (tenantCode) => {
  return axios.get(`/api/1.0/bff/tenants/${tenantCode}/qr-menu`);
};
